<script lang="ts" setup>
interface Props {
  route?: string
}

withDefaults(defineProps<Props>(), {
  route: route('public.marketing.welcome')
})
</script>
<template>
  <Link :href="route">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 895 199"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xml:space="preserve"
      xmlns:serif="http://www.serif.com/"
      style="
        fill-rule: evenodd;
        clip-rule: evenodd;
        stroke-linejoin: round;
        stroke-miterlimit: 2;
      "
    >
      <g transform="matrix(1,0,0,1,-1200.18,-604.492)">
        <g
          id="Capa-1"
          serif:id="Capa 1"
          transform="matrix(4.16667,0,0,4.16667,0,0)"
        >
          <g id="Ícono"></g>
          <g id="Vertical"></g>
          <g id="Cuerpos-de-texto" serif:id="Cuerpos de texto"></g>
          <g id="Horizontal">
            <g transform="matrix(0,46.7398,46.7398,0,307.151,143.841)">
              <path
                d="M0.026,-0.146C0.026,-0.162 0.04,-0.176 0.056,-0.176C0.072,-0.176 0.086,-0.162 0.086,-0.146L0.086,0.146C0.086,0.162 0.072,0.176 0.056,0.176C0.04,0.176 0.026,0.162 0.026,0.146L0.026,-0.146Z"
                style="fill: url(#_Linear1); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(0,46.7398,46.7398,0,298.928,143.841)">
              <path
                d="M0.131,-0.146C0.131,-0.162 0.144,-0.176 0.161,-0.176C0.177,-0.176 0.19,-0.162 0.19,-0.146L0.19,0.146C0.19,0.162 0.177,0.176 0.161,0.176C0.144,0.176 0.131,0.162 0.131,0.146L0.131,-0.146Z"
                style="fill: url(#_Linear2); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(0,46.7398,46.7398,0,296.264,143.841)">
              <path
                d="M0.235,-0.146C0.235,-0.162 0.248,-0.176 0.264,-0.176C0.28,-0.176 0.294,-0.162 0.294,-0.146L0.294,0.146C0.294,0.162 0.28,0.176 0.264,0.176C0.248,0.176 0.235,0.162 0.235,0.146L0.235,-0.146Z"
                style="fill: url(#_Linear3); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(0,46.7398,46.7398,0,297.647,143.841)">
              <path
                d="M0.338,-0.146C0.338,-0.162 0.352,-0.176 0.368,-0.176C0.384,-0.176 0.397,-0.162 0.397,-0.146L0.397,0.146C0.397,0.162 0.384,0.176 0.368,0.176C0.352,0.176 0.338,0.162 0.338,0.146L0.338,-0.146Z"
                style="fill: url(#_Linear4); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(0,46.7398,46.7398,0,301.704,143.841)">
              <path
                d="M0.442,-0.146C0.442,-0.162 0.455,-0.176 0.471,-0.176C0.488,-0.176 0.501,-0.162 0.501,-0.146L0.501,0.146C0.501,0.162 0.488,0.176 0.471,0.176C0.455,0.176 0.442,0.162 0.442,0.146L0.442,-0.146Z"
                style="fill: url(#_Linear5); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(0,46.7398,46.7398,0,307.155,143.841)">
              <path
                d="M0.96,-0.146C0.96,-0.162 0.973,-0.176 0.99,-0.176C1.006,-0.176 1.019,-0.162 1.019,-0.146L1.019,0.146C1.019,0.162 1.006,0.176 0.99,0.176C0.973,0.176 0.96,0.162 0.96,0.146L0.96,-0.146Z"
                style="fill: url(#_Linear6); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(0,46.7398,46.7398,0,315.376,143.841)">
              <path
                d="M0.856,-0.146C0.856,-0.162 0.869,-0.176 0.885,-0.176C0.902,-0.176 0.915,-0.162 0.915,-0.146L0.915,0.146C0.915,0.162 0.902,0.176 0.885,0.176C0.869,0.176 0.856,0.162 0.856,0.146L0.856,-0.146Z"
                style="fill: url(#_Linear7); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(0,46.7398,46.7398,0,318.25,143.841)">
              <path
                d="M0.752,-0.146C0.752,-0.162 0.765,-0.176 0.782,-0.176C0.798,-0.176 0.811,-0.162 0.811,-0.146L0.811,0.146C0.811,0.162 0.798,0.176 0.782,0.176C0.765,0.176 0.752,0.162 0.752,0.146L0.752,-0.146Z"
                style="fill: url(#_Linear8); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(0,46.7398,46.7398,0,316.659,143.841)">
              <path
                d="M0.648,-0.146C0.648,-0.162 0.662,-0.176 0.678,-0.176C0.694,-0.176 0.708,-0.162 0.708,-0.146L0.708,0.146C0.708,0.162 0.694,0.176 0.678,0.176C0.662,0.176 0.648,0.162 0.648,0.146L0.648,-0.146Z"
                style="fill: url(#_Linear9); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(0,46.7398,46.7398,0,312.602,143.841)">
              <path
                d="M0.545,-0.146C0.545,-0.162 0.558,-0.176 0.574,-0.176C0.591,-0.176 0.604,-0.162 0.604,-0.146L0.604,0.146C0.604,0.162 0.591,0.176 0.574,0.176C0.558,0.176 0.545,0.162 0.545,0.146L0.545,-0.146Z"
                style="fill: url(#_Linear10); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,357.518,168.364)">
              <path
                d="M0,0.832C-1.093,0.06 -2.281,-0.618 -3.563,-1.202C-4.846,-1.784 -6.034,-2.375 -7.126,-2.972C-8.219,-3.569 -9.13,-4.247 -9.858,-5.005C-10.588,-5.762 -10.952,-6.71 -10.952,-7.846C-10.952,-9.012 -10.471,-10.025 -9.509,-10.885C-8.547,-11.745 -7.104,-12.175 -5.181,-12.175C-3.549,-12.175 -2.084,-12.023 -0.787,-11.723C-0.297,-11.61 0.147,-11.494 0.548,-11.376C0.59,-11.364 0.624,-11.372 0.662,-11.371C0.809,-11.33 0.954,-11.28 1.113,-11.28C2.056,-11.28 2.819,-12.044 2.819,-12.986C2.819,-13.759 2.296,-14.385 1.592,-14.596C1.553,-14.619 1.519,-14.646 1.463,-14.661C0.977,-14.792 0.438,-14.91 -0.153,-15.017C-1.61,-15.279 -3.229,-15.411 -5.006,-15.411C-8.066,-15.411 -10.427,-14.71 -12.088,-13.312C-13.75,-11.913 -14.581,-10.018 -14.581,-7.628C-14.581,-5.937 -14.216,-4.546 -13.487,-3.453C-12.76,-2.36 -11.848,-1.441 -10.755,-0.699C-9.662,0.045 -8.475,0.679 -7.192,1.203C-5.91,1.728 -4.722,2.289 -3.628,2.886C-2.535,3.484 -1.625,4.169 -0.896,4.941C-0.167,5.714 0.196,6.712 0.196,7.936C0.196,8.811 0.015,9.569 -0.35,10.209C-0.715,10.851 -1.202,11.383 -1.814,11.805C-2.427,12.228 -3.155,12.535 -4,12.724C-4.846,12.913 -5.749,13.007 -6.711,13.007C-8.344,13.007 -9.815,12.831 -11.126,12.476C-11.547,12.362 -12.097,12.193 -12.464,12.074C-12.465,12.073 -12.466,12.073 -12.467,12.073C-12.481,12.068 -12.498,12.063 -12.511,12.059C-12.532,12.052 -12.542,12.058 -12.561,12.054C-12.742,11.989 -12.93,11.938 -13.133,11.938C-14.082,11.938 -14.85,12.707 -14.85,13.655C-14.85,14.424 -14.335,15.051 -13.639,15.27C-13.632,15.278 -13.641,15.296 -13.627,15.3C-13.179,15.437 -12.54,15.614 -12.001,15.74C-10.573,16.075 -8.766,16.243 -6.58,16.243C-4.947,16.243 -3.491,16.039 -2.208,15.63C-0.926,15.223 0.167,14.64 1.071,13.882C1.975,13.124 2.659,12.221 3.125,11.171C3.592,10.123 3.826,8.942 3.826,7.63C3.826,6.027 3.461,4.687 2.732,3.608C2.003,2.53 1.093,1.604 0,0.832"
                style="fill: rgb(105, 31, 117); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,379.509,175.229)">
              <path
                d="M0,4.066C-1.181,5.567 -2.776,6.317 -4.788,6.317C-5.896,6.317 -6.784,6.208 -7.455,5.989C-8.125,5.771 -8.723,5.458 -9.247,5.05L-9.247,-5.793C-8.897,-7.367 -8.292,-8.539 -7.433,-9.312C-6.573,-10.084 -5.399,-10.471 -3.913,-10.471C-2.864,-10.471 -1.982,-10.281 -1.268,-9.903C-0.554,-9.523 0.028,-8.992 0.481,-8.307C0.932,-7.622 1.26,-6.791 1.464,-5.815C1.667,-4.838 1.77,-3.752 1.77,-2.558C1.77,0.357 1.18,2.565 0,4.066M-3.257,-13.531C-4.628,-13.531 -5.844,-13.262 -6.908,-12.723C-7.973,-12.183 -8.839,-11.404 -9.51,-10.384L-9.519,-10.384C-9.362,-10.646 -9.247,-10.935 -9.247,-11.264C-9.247,-12.229 -10.03,-13.012 -10.996,-13.012C-11.961,-13.012 -12.744,-12.229 -12.744,-11.264L-12.744,15.849C-12.744,16.815 -11.961,17.597 -10.996,17.597C-10.03,17.597 -9.247,16.815 -9.247,15.849L-9.247,8.503C-8.519,8.824 -7.841,9.05 -7.214,9.181C-6.588,9.312 -5.735,9.378 -4.657,9.378C-3.141,9.378 -1.764,9.101 -0.525,8.547C0.714,7.994 1.77,7.207 2.645,6.187C3.519,5.167 4.196,3.92 4.677,2.448C5.159,0.977 5.399,-0.678 5.399,-2.515C5.399,-6.419 4.685,-9.232 3.257,-10.952C1.829,-12.672 -0.343,-13.531 -3.257,-13.531"
                style="fill: rgb(105, 31, 117); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,396.274,164.934)">
              <path
                d="M0,16.438C-1.136,16.438 -2.07,16.11 -2.798,15.454C-3.526,14.798 -3.89,13.961 -3.89,12.941C-3.89,12.212 -3.694,11.607 -3.301,11.126C-2.907,10.646 -2.382,10.267 -1.727,9.99C-1.071,9.713 -0.313,9.524 0.547,9.421C1.407,9.319 2.288,9.268 3.192,9.268C3.599,9.268 4.015,9.276 4.438,9.291C4.861,9.305 5.275,9.327 5.683,9.355L5.683,12.984C5.538,13.364 5.312,13.757 5.006,14.165C4.7,14.574 4.313,14.945 3.847,15.279C3.381,15.615 2.827,15.892 2.186,16.11C1.545,16.329 0.816,16.438 0,16.438M9.575,17.066C9.225,15.946 8.962,14.587 8.962,13.509C8.962,12.022 9.007,10.449 9.094,8.788C9.182,7.125 9.225,5.421 9.225,3.672C9.225,2.885 9.145,2.099 8.985,1.312C8.824,0.524 8.504,-0.197 8.023,-0.853C7.542,-1.508 6.842,-2.04 5.924,-2.448C5.006,-2.856 3.789,-3.061 2.273,-3.061C0.67,-3.061 -0.867,-2.9 -2.339,-2.58C-3.202,-2.392 -4.003,-2.144 -4.741,-1.835C-4.771,-1.822 -4.775,-1.804 -4.792,-1.789C-5.378,-1.594 -5.807,-1.06 -5.807,-0.409C-5.807,0.404 -5.148,1.063 -4.334,1.063C-4.244,1.063 -4.155,1.055 -4.069,1.04C-3.949,1.018 -3.843,0.965 -3.735,0.916C-3.719,0.914 -3.714,0.929 -3.694,0.921C-3.155,0.728 -2.587,0.562 -1.989,0.428C-1.392,0.292 -0.808,0.188 -0.24,0.113C0.328,0.037 0.86,0 1.356,0C3.046,0 4.211,0.32 4.853,0.962C5.495,1.603 5.815,2.725 5.815,4.328C5.815,5.028 5.772,5.814 5.683,6.689C5.275,6.631 4.875,6.601 4.482,6.601L3.28,6.601C1.675,6.601 0.211,6.711 -1.114,6.929C-2.441,7.148 -3.578,7.512 -4.524,8.022C-5.472,8.532 -6.208,9.218 -6.733,10.077C-7.257,10.937 -7.52,12.009 -7.52,13.291C-7.52,14.252 -7.352,15.113 -7.016,15.87C-6.682,16.628 -6.223,17.277 -5.64,17.815C-5.057,18.355 -4.365,18.77 -3.563,19.061C-2.762,19.353 -1.895,19.499 -0.961,19.499C-0.029,19.499 0.801,19.396 1.531,19.192C3.547,18.706 5.062,17.982 6.186,17.205C6.169,17.301 6.128,17.389 6.128,17.49C6.128,18.456 6.912,19.239 7.877,19.239C8.843,19.239 9.626,18.456 9.626,17.49C9.626,17.442 9.603,17.402 9.599,17.355C9.617,17.282 9.614,17.19 9.575,17.066"
                style="fill: rgb(105, 31, 117); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,429.325,157.894)">
              <path
                d="M0,-4.766C-0.699,-4.766 -1.275,-4.525 -1.727,-4.044C-2.18,-3.563 -2.404,-2.987 -2.404,-2.317C-2.404,-1.646 -2.18,-1.093 -1.727,-0.656C-1.275,-0.219 -0.699,0 0,0C0.7,0 1.297,-0.219 1.792,-0.656C2.287,-1.093 2.536,-1.646 2.536,-2.317C2.536,-2.987 2.287,-3.563 1.792,-4.044C1.297,-4.525 0.7,-4.766 0,-4.766"
                style="fill: rgb(105, 31, 117); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,489.745,182.294)">
              <path
                d="M0,-18.716C-0.554,-19.415 -1.254,-19.903 -2.1,-20.181C-2.944,-20.457 -3.979,-20.595 -5.203,-20.595C-6.689,-20.595 -8.023,-20.275 -9.203,-19.633C-10.384,-18.992 -11.31,-18.104 -11.979,-16.967C-12.476,-18.307 -13.168,-19.247 -14.057,-19.787C-14.945,-20.326 -16.089,-20.595 -17.488,-20.595C-19.149,-20.595 -20.498,-20.297 -21.532,-19.7C-22.567,-19.102 -23.478,-18.337 -24.265,-17.404L-24.343,-17.404C-24.171,-17.675 -24.045,-17.978 -24.045,-18.322C-24.045,-19.288 -24.828,-20.071 -25.794,-20.071C-26.76,-20.071 -27.544,-19.288 -27.544,-18.322L-27.544,0.13C-27.544,1.096 -26.76,1.879 -25.794,1.879C-24.828,1.879 -24.045,1.096 -24.045,0.13C-24.045,0.128 -24.046,0.127 -24.046,0.126L-24.046,-13.251C-23.696,-14.475 -23.078,-15.495 -22.188,-16.311C-21.299,-17.127 -20.185,-17.535 -18.844,-17.535C-17.97,-17.535 -17.263,-17.389 -16.723,-17.098C-16.184,-16.807 -15.77,-16.369 -15.477,-15.787C-15.186,-15.203 -14.989,-14.482 -14.887,-13.622C-14.785,-12.762 -14.734,-11.749 -14.734,-10.584L-14.734,0.13C-14.734,1.096 -13.951,1.879 -12.985,1.879C-12.019,1.879 -11.236,1.096 -11.236,0.13L-11.236,-12.813C-10.886,-14.328 -10.304,-15.495 -9.487,-16.311C-8.672,-17.127 -7.535,-17.535 -6.077,-17.535C-5.203,-17.535 -4.497,-17.411 -3.957,-17.164C-3.418,-16.915 -2.995,-16.537 -2.688,-16.027C-2.383,-15.517 -2.18,-14.875 -2.077,-14.103C-1.976,-13.33 -1.925,-12.42 -1.925,-11.371L-1.925,0.13C-1.925,1.096 -1.142,1.879 -0.176,1.879C0.79,1.879 1.573,1.096 1.573,0.13L1.573,-11.327C1.573,-13.164 1.449,-14.678 1.202,-15.874C0.954,-17.069 0.553,-18.016 0,-18.716"
                style="fill: rgb(105, 31, 117); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,497.505,159.422)">
              <path
                d="M0,-0.54L-0.632,-0.54L-0.632,-1.86C-0.558,-1.897 -0.458,-1.918 -0.334,-1.925C-0.211,-1.931 -0.08,-1.934 0.056,-1.934C0.774,-1.934 1.134,-1.717 1.134,-1.284C1.134,-1.011 1.035,-0.819 0.837,-0.707C0.639,-0.596 0.359,-0.54 0,-0.54M0.837,-0.057C1.208,-0.081 1.521,-0.199 1.775,-0.41C2.029,-0.621 2.156,-0.924 2.156,-1.321C2.156,-1.853 1.97,-2.228 1.599,-2.446C1.228,-2.662 0.781,-2.77 0.261,-2.77C-0.062,-2.77 -0.402,-2.755 -0.762,-2.724C-1.121,-2.693 -1.399,-2.646 -1.598,-2.585L-1.598,2.23L-0.632,2.23L-0.632,0.017L0.261,0.297L1.599,2.23L2.732,2.23L1.357,0.203L0.837,-0.057Z"
                style="fill: rgb(105, 31, 117); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,501.288,157.554)">
              <path
                d="M0,3.401C-0.193,3.878 -0.456,4.274 -0.791,4.59C-1.125,4.907 -1.521,5.142 -1.98,5.297C-2.438,5.452 -2.935,5.528 -3.467,5.528C-3.976,5.528 -4.459,5.449 -4.917,5.288C-5.376,5.127 -5.775,4.888 -6.116,4.571C-6.457,4.255 -6.726,3.859 -6.924,3.382C-7.122,2.905 -7.222,2.345 -7.222,1.7C-7.222,1.056 -7.129,0.495 -6.942,0.018C-6.757,-0.459 -6.497,-0.856 -6.162,-1.172C-5.827,-1.488 -5.432,-1.726 -4.973,-1.887C-4.515,-2.048 -4.013,-2.129 -3.467,-2.129C-2.946,-2.129 -2.46,-2.048 -2.008,-1.887C-1.556,-1.726 -1.159,-1.488 -0.818,-1.172C-0.478,-0.856 -0.208,-0.459 -0.01,0.018C0.188,0.495 0.287,1.056 0.287,1.7C0.287,2.357 0.191,2.924 0,3.401M1.077,-0.41C0.823,-1.023 0.474,-1.537 0.027,-1.953C-0.419,-2.368 -0.942,-2.683 -1.543,-2.9C-2.145,-3.117 -2.785,-3.225 -3.467,-3.225C-4.137,-3.225 -4.769,-3.117 -5.362,-2.9C-5.958,-2.683 -6.481,-2.368 -6.934,-1.953C-7.386,-1.537 -7.742,-1.023 -8.002,-0.41C-8.262,0.203 -8.393,0.907 -8.393,1.7C-8.393,2.493 -8.266,3.196 -8.012,3.809C-7.758,4.423 -7.407,4.937 -6.961,5.352C-6.516,5.768 -5.995,6.084 -5.399,6.3C-4.806,6.517 -4.162,6.626 -3.467,6.626C-2.798,6.626 -2.166,6.517 -1.571,6.3C-0.977,6.084 -0.453,5.768 0,5.352C0.451,4.937 0.808,4.423 1.068,3.809C1.328,3.196 1.459,2.493 1.459,1.7C1.459,0.907 1.331,0.203 1.077,-0.41"
                style="fill: rgb(105, 31, 117); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,421.379,160.391)">
              <path
                d="M0,20.714C-0.163,20.714 -0.313,20.756 -0.46,20.807C-0.472,20.809 -0.477,20.799 -0.492,20.804C-0.611,20.844 -0.728,20.881 -0.841,20.915C-1.365,21.076 -2.007,21.155 -2.764,21.155C-3.668,21.155 -4.311,20.843 -4.687,20.216C-5.067,19.589 -5.257,18.519 -5.257,17.003L-5.257,4.892L0.689,4.892L0.689,1.832L-5.257,1.832L-5.257,-3.502L-8.754,-2.496L-8.754,1.832L-12.164,1.832L-12.164,4.892L-8.754,4.892L-8.754,17.658C-8.754,20.02 -8.39,21.702 -7.661,22.708C-6.934,23.714 -5.68,24.216 -3.901,24.216C-2.823,24.216 -1.817,24.099 -0.885,23.866C-0.414,23.749 0.039,23.612 0.473,23.457C0.516,23.442 0.537,23.418 0.557,23.393C1.053,23.175 1.407,22.697 1.407,22.121C1.407,21.344 0.777,20.714 0,20.714"
                style="fill: rgb(105, 31, 117); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,429.413,184.173)">
              <path
                d="M0,-21.95C-0.967,-21.95 -1.749,-21.167 -1.749,-20.201L-1.749,-1.749C-1.749,-0.783 -0.967,0 0,0C0.966,0 1.748,-0.783 1.748,-1.749L1.748,-20.201C1.748,-21.167 0.966,-21.95 0,-21.95"
                style="fill: rgb(105, 31, 117); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,453.72,185.685)">
              <path
                d="M0,-23.462C-0.966,-23.462 -1.749,-22.679 -1.749,-21.713L-1.749,-11.002C-1.749,-9.865 -1.814,-8.866 -1.945,-8.007C-2.076,-7.147 -2.653,-6.156 -3.457,-5.437C-3.943,-5.002 -5.089,-4.178 -6.72,-4.138C-8.714,-4.09 -9.852,-5.069 -10.353,-5.486C-11.312,-6.285 -11.807,-7.599 -11.935,-8.624C-12.043,-9.487 -11.935,-21.713 -11.935,-21.713C-11.935,-22.679 -12.718,-23.462 -13.685,-23.462C-14.65,-23.462 -15.433,-22.679 -15.433,-21.713L-15.433,-10.258C-15.433,-8.451 -15.223,-6.971 -14.974,-5.778C-14.262,-2.367 -10.016,0 -5.674,-0.448C-0.999,-0.931 0.984,-4.597 1.29,-5.778C1.597,-6.958 1.749,-8.451 1.749,-10.258L1.749,-21.713C1.749,-22.679 0.967,-23.462 0,-23.462"
                style="fill: rgb(105, 31, 117); fill-rule: nonzero"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="_Linear1"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1,0,0,-1,0,-3.16005e-05)"
        >
          <stop
            offset="0"
            style="stop-color: rgb(222, 220, 0); stop-opacity: 1"
          />
          <stop
            offset="0.33"
            style="stop-color: rgb(148, 193, 31); stop-opacity: 1"
          />
          <stop
            offset="0.67"
            style="stop-color: rgb(0, 159, 227); stop-opacity: 1"
          />
          <stop
            offset="1"
            style="stop-color: rgb(102, 35, 131); stop-opacity: 1"
          />
        </linearGradient>
        <linearGradient
          id="_Linear2"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1,0,0,-1,0,1.16389e-05)"
        >
          <stop
            offset="0"
            style="stop-color: rgb(222, 220, 0); stop-opacity: 1"
          />
          <stop
            offset="0.33"
            style="stop-color: rgb(148, 193, 31); stop-opacity: 1"
          />
          <stop
            offset="0.67"
            style="stop-color: rgb(0, 159, 227); stop-opacity: 1"
          />
          <stop
            offset="1"
            style="stop-color: rgb(102, 35, 131); stop-opacity: 1"
          />
        </linearGradient>
        <linearGradient
          id="_Linear3"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1,0,0,-1,0,7.65942e-06)"
        >
          <stop
            offset="0"
            style="stop-color: rgb(222, 220, 0); stop-opacity: 1"
          />
          <stop
            offset="0.33"
            style="stop-color: rgb(148, 193, 31); stop-opacity: 1"
          />
          <stop
            offset="0.67"
            style="stop-color: rgb(0, 159, 227); stop-opacity: 1"
          />
          <stop
            offset="1"
            style="stop-color: rgb(102, 35, 131); stop-opacity: 1"
          />
        </linearGradient>
        <linearGradient
          id="_Linear4"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1,0,0,-1,0,-2.7591e-05)"
        >
          <stop
            offset="0"
            style="stop-color: rgb(222, 220, 0); stop-opacity: 1"
          />
          <stop
            offset="0.33"
            style="stop-color: rgb(148, 193, 31); stop-opacity: 1"
          />
          <stop
            offset="0.67"
            style="stop-color: rgb(0, 159, 227); stop-opacity: 1"
          />
          <stop
            offset="1"
            style="stop-color: rgb(102, 35, 131); stop-opacity: 1"
          />
        </linearGradient>
        <linearGradient
          id="_Linear5"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1,0,0,-1,0,-2.46856e-05)"
        >
          <stop
            offset="0"
            style="stop-color: rgb(222, 220, 0); stop-opacity: 1"
          />
          <stop
            offset="0.33"
            style="stop-color: rgb(148, 193, 31); stop-opacity: 1"
          />
          <stop
            offset="0.67"
            style="stop-color: rgb(0, 159, 227); stop-opacity: 1"
          />
          <stop
            offset="1"
            style="stop-color: rgb(102, 35, 131); stop-opacity: 1"
          />
        </linearGradient>
        <linearGradient
          id="_Linear6"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1,0,0,-1,0,3.86394e-06)"
        >
          <stop
            offset="0"
            style="stop-color: rgb(222, 220, 0); stop-opacity: 1"
          />
          <stop
            offset="0.33"
            style="stop-color: rgb(148, 193, 31); stop-opacity: 1"
          />
          <stop
            offset="0.67"
            style="stop-color: rgb(0, 159, 227); stop-opacity: 1"
          />
          <stop
            offset="1"
            style="stop-color: rgb(102, 35, 131); stop-opacity: 1"
          />
        </linearGradient>
        <linearGradient
          id="_Linear7"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1,0,0,-1,0,-1.6671e-05)"
        >
          <stop
            offset="0"
            style="stop-color: rgb(222, 220, 0); stop-opacity: 1"
          />
          <stop
            offset="0.33"
            style="stop-color: rgb(148, 193, 31); stop-opacity: 1"
          />
          <stop
            offset="0.67"
            style="stop-color: rgb(0, 159, 227); stop-opacity: 1"
          />
          <stop
            offset="1"
            style="stop-color: rgb(102, 35, 131); stop-opacity: 1"
          />
        </linearGradient>
        <linearGradient
          id="_Linear8"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1,0,0,-1,0,-3.91957e-06)"
        >
          <stop
            offset="0"
            style="stop-color: rgb(222, 220, 0); stop-opacity: 1"
          />
          <stop
            offset="0.33"
            style="stop-color: rgb(148, 193, 31); stop-opacity: 1"
          />
          <stop
            offset="0.67"
            style="stop-color: rgb(0, 159, 227); stop-opacity: 1"
          />
          <stop
            offset="1"
            style="stop-color: rgb(102, 35, 131); stop-opacity: 1"
          />
        </linearGradient>
        <linearGradient
          id="_Linear9"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1,0,0,-1,0,1.15961e-06)"
        >
          <stop
            offset="0"
            style="stop-color: rgb(222, 220, 0); stop-opacity: 1"
          />
          <stop
            offset="0.33"
            style="stop-color: rgb(148, 193, 31); stop-opacity: 1"
          />
          <stop
            offset="0.67"
            style="stop-color: rgb(0, 159, 227); stop-opacity: 1"
          />
          <stop
            offset="1"
            style="stop-color: rgb(102, 35, 131); stop-opacity: 1"
          />
        </linearGradient>
        <linearGradient
          id="_Linear10"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1,0,0,-1,0,-1.74584e-06)"
        >
          <stop
            offset="0"
            style="stop-color: rgb(222, 220, 0); stop-opacity: 1"
          />
          <stop
            offset="0.33"
            style="stop-color: rgb(148, 193, 31); stop-opacity: 1"
          />
          <stop
            offset="0.67"
            style="stop-color: rgb(0, 159, 227); stop-opacity: 1"
          />
          <stop
            offset="1"
            style="stop-color: rgb(102, 35, 131); stop-opacity: 1"
          />
        </linearGradient>
      </defs>
    </svg>
  </Link>
</template>
